@if (!isServer) {
<p-dialog
  ngSkipHydration
  [header]="header"
  [modal]="true"
  [(visible)]="isVisible"
  class="pm-dialog"
  [ngClass]="{
    'pm-dialog-auto-width': autoWidth,
  }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="close()"
  [closable]="closable"
  [styleClass]="styleClass"
  #pDialogComponent
>
  <ng-template pTemplate="header">
    <div
      class="pm-dialog-header"
      [ngClass]="{ 'dialog-header-border': !hideHeaderBorder }"
    >
      <div class="pm-header-icon mr-2" *ngIf="headerIcon">
        <pm-icon [icon]="headerIcon" />
      </div>
      <div class="pm-header-icon mr-2" *ngIf="emoji">
        <pm-emoji [emoji]="emoji" [size]="emojiSize" />
      </div>
      <div class="pm-header-title">{{ header }}</div>
    </div>
  </ng-template>
  <div class="pm-dialog-container">
    <ng-content />

    @if (!hideActions) {
    <div class="dialog-actions-placeholder"></div>
    <div
      class="flex justify-content-end mt-auto dialog-actions"
      [ngClass]="{ 'dialog-actions-border': !hideActionsBorder }"
    >
      @if (customActionsTemplate) {

      <ng-container *ngTemplateOutlet="customActionsTemplate"></ng-container>

      } @else {
      <pm-button
        *ngIf="!hideCancelButton"
        [label]="cancelButtonLabel"
        class="ml-2-5 mr-2-5"
        (clickEvent)="close()"
        [type]="PMButtonTypeEnum.SECONDARY"
      ></pm-button>
      <pm-button
        *ngIf="!hideSaveButton"
        [ngStyle]="{ flex: confirmButtonFullWidth ? 1 : 'unset' }"
        [label]="confirmButtonLabel"
        (clickEvent)="save()"
        [type]="PMButtonTypeEnum.PRIMARY"
        [disabled]="saveDisabled"
        [fullWidth]="confirmButtonFullWidth"
      ></pm-button>

      }
    </div>
    }
  </div> </p-dialog
>}
